import CheckoutForm from "@components/CheckoutForm"
import Layout from "@components/Layout"
import { getOnboardingContext } from "@helpers/localStorage"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { User } from "@supabase/supabase-js"
import { useTranslation } from "react-i18next"
import { Navigate, useLoaderData, useSearchParams } from "react-router-dom"
import { Plan } from "src/types"

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string,
)

export default function PaymentPage() {
  const [searchParams] = useSearchParams()
  const user = useLoaderData() as User

  const clientSecret = searchParams.get("client_secret")!
  const currency = searchParams.get("currency")!
  const fullPrice = searchParams.get("full_price")!
  const nextPriceId = searchParams.get("next_price_id") ?? ""
  const plan = searchParams.get("plan")! as Plan
  const priceId = searchParams.get("price_id")!
  const subscriptionId = searchParams.get("subscription_id") ?? ""
  const paymentIntentId = searchParams.get("payment_intent_id") ?? ""

  const { t } = useTranslation()
  const context = getOnboardingContext()
  const paymentCopyKey =
    context === "cars"
      ? "pages.checkout.paymentCars"
      : context === "pets"
        ? "pages.checkout.paymentPets"
        : "pages.checkout.payment"

  if (!clientSecret) return <Navigate replace to="/checkout/plans" />

  return (
    <Layout>
      <div className="shrink-0 space-y-2">
        <p className="font-semibold">
          {t(`${paymentCopyKey}.securePaymentTitle`)}
        </p>

        <p>{t(`${paymentCopyKey}.securePaymentText`)}</p>

        <p className="font-semibold">
          {t(`${paymentCopyKey}.moneyBackGuaranteeTitle`)}
        </p>

        <p>{t(`${paymentCopyKey}.moneyBackGuaranteeText`)}</p>
      </div>

      <div className="flex grow">
        <Elements
          options={{
            appearance: { theme: "flat" },
            clientSecret,
          }}
          stripe={stripePromise}
        >
          <CheckoutForm
            clientSecret={clientSecret}
            currency={currency}
            fullPrice={parseFloat(fullPrice)}
            plan={plan}
            stripeFirstPriceId={priceId}
            stripeNextPriceId={nextPriceId}
            subscriptionId={subscriptionId}
            paymentIntentId={paymentIntentId}
            userEmail={user.email}
          />
        </Elements>
      </div>
    </Layout>
  )
}
